import actions from './actions';
import mutations from './mutations';

const state = {
    appliedUpdates: {},
    appliedUpdateIds: [],
    complispacePublished: {},
    complispacePublishedIds: []
};

const getters = {
    appliedItems: state => state.appliedUpdateIds.map(
        id => state.appliedUpdates[id]
    ),
    complispaceItems: state => state.complispacePublishedIds.map(
        id => state.complispacePublished[id]
    ),
    getAppliedPublished: state => id => state.appliedUpdates[id],
    getComplispacePublished: state => id => state.complispacePublished[id]
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/published/store.js